import ProMarketingFeatures from './ProMarketingFeatures';

export default ProMarketingFeatures;